import { createSelector } from '@ngrx/store';
import {
  selectDeleting,
  selectLoadingCards,
  selectUpdating,
} from './credit-card-vault.selectors';
import { selectCheckoutLoading } from './checkout.selectors';
import { selectAuthLoading } from './auth.selectors';
import { selectLocalChannelLoading } from './local-channel.selectors';
import { selectStateLoading } from './status.selectors';
import { selectCustomerLoading, selectPaymentLoading } from './pay.selectors';
import { selectStoreLoading } from './store.selectors';
import { selectWorkDayLoading } from './work-day.selectors';
import { selectClientLoading } from './client.selectors';

export const selectAnyLoading = createSelector(
  selectAuthLoading,
  selectLoadingCards,
  selectCheckoutLoading,
  selectLocalChannelLoading,
  selectStateLoading,
  selectCustomerLoading,
  selectPaymentLoading,
  selectStoreLoading,
  selectWorkDayLoading,
  selectClientLoading,
  (...loadingStates: boolean[]) => loadingStates.some((state) => state)
);

export const selectAnyDeleting = createSelector(
  selectDeleting,
  (...loadingStates: boolean[]) => loadingStates.some((state) => state)
);

export const selectAnyUpdating = createSelector(
  selectUpdating,
  (...loadingStates: boolean[]) => loadingStates.some((state) => state)
);

